export const LITERS_IN_ONE_GALLON = 3.78541
export const KILOGRAMS_IN_ONE_POUND = 0.45359237
